import posthog from "posthog-js";

/**
 * Track a custom event via PostHog.
 * No-op if PostHog is not initialized (SSR, ad blocker).
 */
export function trackEvent(name: string, properties?: Record<string, unknown>): void {
  if (typeof window !== "undefined" && posthog.__loaded) {
    posthog.capture(name, properties);
  }
}

/**
 * Report an exception to PostHog Error Tracking.
 * Use in catch blocks where the error is handled (shown to user)
 * but should still appear in Error Tracking for the founder.
 */
export function captureException(
  error: unknown,
  additionalProperties?: Record<string, unknown>
): void {
  if (typeof window !== "undefined" && posthog.__loaded) {
    posthog.captureException(
      error instanceof Error ? error : new Error(String(error)),
      additionalProperties
    );
  }
}

/**
 * Identify the current user in PostHog so all events are attributed.
 */
export function identifyUser(userId: string, properties?: Record<string, unknown>): void {
  if (typeof window !== "undefined" && posthog.__loaded) {
    posthog.identify(userId, properties);
  }
}

/**
 * Reset PostHog identity (call on logout).
 */
export function resetUser(): void {
  if (typeof window !== "undefined" && posthog.__loaded) {
    posthog.reset();
  }
}
